import {
  createComponentClickedEvent,
  createScreenViewedEvent,
  createSubmittedEvent,
  track,
} from "./base"
import { type AppScreen } from "@/constants/Screens"
import { type AnalysisCompInput } from "@/generated/graphql"

export const customizeCompsViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Customize Comps",
      from_screen: "Analyze",
    })
  )
}

export const customizeCompsSubmitted = (compInput: AnalysisCompInput) => {
  track(
    createSubmittedEvent({
      object_name: "Customize Comps",
      current_screen: "Customize Comps",
      to_screen: "Analyze",
      component_type: "button",
      component_text: "Save",
      submitted_values: {
        distance: compInput.distance,
        days_since_sold: compInput.daysSinceSold,
        listing_status: compInput.listingStatuses,
        sqft_min: compInput.areaMin,
        sqft_max: compInput.areaMax,
        beds_min: compInput.bedsMin,
        baths_min: compInput.bathsMin,
      },
    })
  )
}

export const customizeCompsExitWithoutSaving = ({
  currentScreen,
  toScreen,
}: {
  currentScreen: AppScreen
  toScreen: AppScreen
}) => {
  track(
    createComponentClickedEvent({
      current_screen: currentScreen,
      to_screen: toScreen,
      component_type: "button",
      component_function: "exit customize comps menu without saving",
    })
  )
}

export const customizeCompsResetToDefaults = ({
  analysisId,
  previousValues,
  currentValues,
}: {
  analysisId: string
  previousValues: AnalysisCompInput
  currentValues: AnalysisCompInput
}) => {
  const preferenceProperties = {
    object_name: "Reset to Defaults",
    component_type: "button",
    component_text: "Reset to Default",
    component_function: "resets filters to default",
    submitted_values: {
      analysis_id: analysisId,
      previous_values: { ...previousValues },
      current_values: JSON.stringify(currentValues),
    },
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  track(createSubmittedEvent(preferenceProperties as any))
}
